import { render, staticRenderFns } from "./AttendanceList.vue?vue&type=template&id=1f20a59b&scoped=true&"
import script from "./AttendanceList.vue?vue&type=script&lang=js&"
export * from "./AttendanceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f20a59b",
  null
  
)

export default component.exports